export default "__VITE_ASSET__B7SDF4ba__"